// The inspection report cover date line, shared so the editor preview
// (CoverSheet) and the PDF generator cannot drift apart: both render the same
// string from the same date formatting and the same separator.

/** Long-form inspection date ("July 27, 2026"); '' when unset, raw when unparseable. */
export function formatInspectionDate(date: string): string {
  if (!date) return '';
  const d = new Date(`${date}T00:00:00`);
  if (Number.isNaN(d.getTime())) return date;
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

/**
 * The cover's date line: "Inspection date: July 27, 2026 · NC-26-433".
 * Either half is optional — jobs without a code keep the plain date line, and a
 * report with no date but a coded job shows the code alone. Returns '' when
 * there is neither, so callers omit the line entirely.
 */
export function inspectionCoverDateLine(date: string, jobCode?: string | null): string {
  const formatted = formatInspectionDate(date);
  const code = jobCode?.trim() ?? '';
  const dated = formatted ? `Inspection date: ${formatted}` : '';
  return [dated, code].filter(Boolean).join(' · ');
}
